import { Component, Input, OnInit } from '@angular/core';
import { setRecipientData } from 'app/global/get-recipient-data';
import { RecipientRole } from '../participants/participants.dto';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Action } from './send-reminder.enum';
import { SendReminderService } from './send-reminder.service';
import { Recipient } from 'app/main/pages/edit-template/edit-template.dto';
import { GlobalService } from 'app/global/global.service';
import { FormGroup, FormBuilder } from '@angular/forms';
@Component({
  selector: 'app-send-reminder',
  templateUrl: './send-reminder.component.html',
  styleUrl: './send-reminder.component.scss'
})

export class SendReminderComponent implements OnInit {
  @Input() party: RecipientRole;
  public recipient: Recipient
  public document_id: number = 0;
  public loaders = { sms: false, email: false, both: false };
  public isSendReminder: boolean = false;
  public formSubmitted: boolean = false;
  public action = Action
  public send_reminder_form: FormGroup;
  constructor(
    public activeModal: NgbActiveModal,
    private sendReminderService: SendReminderService,
    private globalService: GlobalService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.recipient = setRecipientData(this.party.personfields);
    this.document_id = this.party.roleable_id;
    this.initForm(this.recipient);
  }

  initForm(recipient:Recipient){
    this.send_reminder_form = this.fb.group({
      phone_no: [recipient.phone_no],
    })
  }

  /**
   * send reminder
   * @param action 
   */
  sendReminder(action: Action) {
    this.formSubmitted = true;
    if((action === this.action.SMS || action === this.action.BOTH) && (this.send_reminder_form.invalid || !this.send_reminder_form.get('phone_no').value)){
      return;
    }
    this.formSubmitted = false;
    this.isSendReminder = true;
    this.loaders[action] = true;
    this.sendReminderService.sendReminder(this.document_id, { recipient_role_id: this.party.id, action: action, phone_no: (action === this.action.EMAIL ? '' :this.send_reminder_form.get('phone_no').value?.e164Number) }).subscribe({
      next: () => {
          this.activeModal.close();
      },
      error : (error) => {
        this.formSubmitted = false;
        this.isSendReminder = false;
        this.loaders[action] = false;
        this.globalService.toastrError(error);
      }
    });
  }

}
